module.exports = __webpack_public_path__ + "static/ealogonew-caf195d8260df2d76504b327d7f9499c.png";